var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"textarea"},[_c('Input',{attrs:{"value":_vm.text,"disabled":_vm._disabled,"type":"textarea","rows":3,"controls":false,"size":"medium"},on:{"input":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }